export const PROFILE_ROUTES = {
  ROOT: "profile",
  BUSINESS_SECTORS: "business-sectors",
};
